import { FC, ReactNode } from 'react';
import { Link, LinkProps } from '@mui/material';

export interface ExternalLinkType extends LinkProps {
	path?: string;
	children: ReactNode;
}

const ExternalLink: FC<ExternalLinkType> = ({ path, href, children, ...rest }) => (
	<Link href={path ?? href} target={'_blank'} {...rest}>
		{children}
	</Link>
);

export default ExternalLink;
